import React, { useState } from 'react';
import { Smartphone, X } from 'lucide-react';
import useMediaQuery from '../utils/useMediaQuery';

export const OFFER_KEY = 'mobile_view_offer_dismissed';

// /m/* (receiving inbox, today, sync) and /mobile/* are already the phone screens; offering them is noise.
export const onMobileScreen = (pathname = '') => /^\/(m|mobile)(\/|$)/.test(pathname);

/** On a phone, offer the mobile view once; the same session carries over, so no second sign-in. */
export default function MobileViewOffer({ pathname = '' }) {
  const isPhone = useMediaQuery('(max-width: 639px)', false);
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(OFFER_KEY) === '1'; } catch { return true; }
  });
  if (!isPhone || hidden || onMobileScreen(pathname)) return null;
  const dismiss = () => {
    try { localStorage.setItem(OFFER_KEY, '1'); } catch { /* storage off */ }
    setHidden(true);
  };
  return (
    <div className="flex items-center gap-3 px-4 py-3 bg-primary-50 border-t border-primary-200 text-sm text-ink" data-testid="mobile-view-offer">
      <Smartphone className="w-5 h-5 text-primary-600 shrink-0" aria-hidden="true" />
      <span className="flex-1">On a phone? The mobile view has big buttons for receiving, scanning and temperature checks.</span>
      <a href="/mobile/dashboard" data-testid="mobile-view-offer-open"
        className="shrink-0 inline-flex items-center min-h-[44px] px-3 rounded-lg bg-primary-500 text-surface font-medium">Open</a>
      <button type="button" onClick={dismiss} aria-label="Not now" data-testid="mobile-view-offer-dismiss"
        className="shrink-0 min-h-[44px] min-w-[44px] inline-flex items-center justify-center rounded-lg text-ink-muted">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
